import script from "./SddsIconCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./SddsIconCustom.vue?vue&type=script&setup=true&lang=js"

import "./SddsIconCustom.vue?vue&type=style&index=0&id=d28ec616&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d28ec616"]])

export default __exports__